LS.util.route({
	'feed': {
		'$root': {
			':load': 'feed',
			':unload': 'feed:unload'
		},
		'specs': {
			'$any': {
				':load': 'article',
				':unload': 'article:unload'
			}
		}
	}
});